// Generated by ReScript, PLEASE EDIT WITH CARE


function createVehicleCategoryLabel(vehicleName, vehicleId) {
  return "" + vehicleName + "(" + vehicleId + ")";
}

export {
  createVehicleCategoryLabel ,
  
}
/* No side effect */
